import { Component } from '@verndale/core';
import { CountUp } from 'countup.js';
import { inView } from 'motion';
import { initBorderAnimation } from '../helpers/index';

class LanguageSelector extends Component {
  setupDefaults() {
    this.dom = {
      links: this.el.querySelectorAll('.language-selector__link')
    };
  }

  addListeners() {
    this.dom.links.forEach(link => {
      link.addEventListener('click', this.handleClick.bind(this));
    });
  }

  handleClick(event) {
    // event.preventDefault();
    // const target = event.currentTarget;

    // this.dom.links.forEach(link => {
    //   link.classList.remove('language-selector__link--active');
    // });

    // target.classList.add('language-selector__link--active');
  }
}

export default LanguageSelector;
